var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "roll" } }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.switchtab(0)
            },
          },
        },
        [_c("span", { class: { active: _vm.category == 0 } }, [_vm._v("全部")])]
      ),
      _c("div", { staticClass: "line" }),
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.switchtab(1)
            },
          },
        },
        [_c("span", { class: { active: _vm.category == 1 } }, [_vm._v("官方")])]
      ),
      _c("div", { staticClass: "line" }),
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.switchtab(2)
            },
          },
        },
        [_c("span", { class: { active: _vm.category == 2 } }, [_vm._v("主播")])]
      ),
      _c("div", { staticClass: "line" }),
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.switchtab(4)
            },
          },
        },
        [
          _c("span", { class: { active: _vm.category == 4 } }, [
            _vm._v("已结束"),
          ]),
        ]
      ),
    ]),
    _c(
      "ul",
      { staticClass: "roll-room-list" },
      [
        _vm._l(_vm.rollData, function (item) {
          return _c(
            "li",
            {
              staticClass: "roll",
              on: {
                click: function ($event) {
                  return _vm.pathGo({
                    name: "rollDetail",
                    params: { id: item.id },
                  })
                },
              },
            },
            [_c("c-RoomItem", { attrs: { room: item } })],
            1
          )
        }),
        _c("li"),
        _c("li"),
        _c("li"),
        _c("li"),
        _c("li"),
        _c("li"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }